import React from "react";

import NotificationDropdown from "components/navbar/top/NotificationDropdown";
import ProfileDropdown from "components/navbar/top/ProfileDropdown";
import { Nav } from "react-bootstrap";
import NineDotMenu from "./NineDotMenu";
import ThemeControlDropdown from "./ThemeControlDropdown";
import LanguageControlDropdown from "./LanguageControlDropdown";
import SearchBoxCustom from "./SearchBoxCustom";
import { topNavbarBreakpoint } from "config";

const TopNavRightSideNavItem = () => {
  return (
    <Nav
      navbar
      className="navbar-nav-icons ms-auto flex-row align-items-center"
      as="ul"
      style={{ height: "5px" }}
    >
      <div className={`d-none d-${topNavbarBreakpoint}-block`}>
        <SearchBoxCustom />
      </div>
      <LanguageControlDropdown />
      <ThemeControlDropdown />
      <NotificationDropdown />
      {/* <NineDotMenu /> */}
      <ProfileDropdown />
    </Nav>
  );
};

export default TopNavRightSideNavItem;
